import { mkassaApi } from 'redux/services/mkassa'

import { AppLoader } from 'components/AppLoader'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'

import { Mkassa } from 'models/mkassa'

import { DocumentsList } from 'shared/ui'

import styles from './Details.module.scss'
import { formatDate } from 'shared/libs'

interface DetailsProps {
  id: Mkassa['id']
  onClose: () => void
}

export const Details = ({ id, onClose }: DetailsProps) => {
  const { data, isLoading, isSuccess, error } =
    mkassaApi.useGetMkassaByIdQuery(id)

  function renderValue(label: string, key: keyof Mkassa) {
    if (data?.[key]) {
      return (
        <div className={styles.item}>
          <div className={styles.itemName}>{label}</div>
          <div className={styles.itemText}>{data?.[key]}</div>
        </div>
      )
    }
    return null
  }

  if (isLoading) return <AppLoader />

  if (isSuccess) {
    return (
      <>
        <AppModalHeader onClose={onClose} title={id} />
        <div className={styles.container}>
          <div className={styles.item}>
            <div className={styles.itemName}>QR</div>
            <div className={styles.itemText}>{data.count_qr}</div>
          </div>

          {renderValue('JIRA', 'jira_key')}
          <div className={styles.item}>
            <div className={styles.itemName}>Дата создания</div>
            <div className={styles.itemText}>{formatDate(data.created_at)}</div>
          </div>
          {renderValue('Наименование предприятия', 'name')}
          {renderValue('Наименование торговой точки', 'name_point')}
          {renderValue('Адрес торговой точки', 'point_address')}
          {renderValue('Номер телефона', 'phone_number')}
          {renderValue('Электронная почта', 'email')}
          {renderValue('Тип запроса', 'get_type_request_display')}
          {renderValue('РКО', 'rko_account')}
          {renderValue('Транзитный счет 1', 'transit_1')}
          {renderValue('Транзитный счет 2', 'transit_2')}
          {renderValue('Доработки по заявке (Вопрос)', 'revision_application')}
          {renderValue('Ответ', 'customfield_14725')}

          {data.consultant ? (
            <>
              <div className={styles.item}>
                <div className={styles.itemName}>Консультант</div>
                <div className={styles.itemText}>
                  <strong>ФИО:</strong>
                  <span>{data.consultant.full_name}</span>
                </div>
                <div className={styles.itemText}>
                  <strong>Тип подразделения:</strong>
                  <span>{data.consultant.get_type_division_display}</span>
                </div>
                <div className={styles.itemText}>
                  <strong></strong>
                  <span>{data.consultant.main_branch}</span>
                </div>
                <div className={styles.itemText}>
                  <strong></strong>
                  <span>{data.consultant.branches}</span>
                </div>
              </div>
            </>
          ) : null}

          {data.merchant ? (
            <>
              <div className={styles.item}>
                <div className={styles.itemName}>Мерчант</div>
                <div className={styles.itemText}>
                  <strong>ID:</strong>
                  <span>{data.merchant.id}</span>
                </div>
                <div className={styles.itemText}>
                  <strong>Наименование:</strong>
                  <span>{data.merchant.name}</span>
                </div>
              </div>
            </>
          ) : null}

          {data.documents ? (
            <>
              <DocumentsList
                title="Документы"
                list={[
                  { id: 1, file: data.documents.front_passport },
                  { id: 2, file: data.documents.back_passport },
                ]}
              />

              <DocumentsList
                title="Патент"
                list={[
                  { id: 1, file: data.documents.front_patent },
                  { id: 2, file: data.documents.back_patent },
                ]}
              />
            </>
          ) : null}

          <DocumentsList list={data.other_documents} />
        </div>
      </>
    )
  }

  return <code>{JSON.stringify(error)}</code>
}
